import { fromJS, Map, OrderedMap, OrderedSet, Set } from 'immutable';

import { TypedMap } from 'utils/typed-map';
import Donation from 'entities/donation/model';
import { DonationActions } from 'entities/donation/actions';

import {
  ADD,
  ADD_MULTIPLE,
  SET_DISPLAYED_DONATION_IDS,
  SET_DONATIONS_LOADED,
  SET_TOTAL,
  SET_PENDING_EXTERNAL_TOTAL,
  UPDATE_MULTIPLE,
  UPDATE_DONATION_DESIRED_AMOUNT,
} from './constants';

type MutableState = {
  donations: OrderedMap<string, Donation>;
  total: number;
  pendingExternalTotal: number | null;
  donationsLoaded: Set<string>;
  displayedDonationIds: OrderedSet<string>;
};

const mutableState: MutableState = {
  donations: OrderedMap<string, Donation>(),
  total: 0,
  pendingExternalTotal: null,
  donationsLoaded: Set(),
  displayedDonationIds: OrderedSet(),
};

export type DonationState = Map<string, any> & TypedMap<MutableState>;

const initialState: DonationState = fromJS(mutableState);

export default (state: DonationState = initialState, action: DonationActions): DonationState => {
  switch (action.type) {
    case ADD:
      return state.set(
        'donations',
        state.get('donations').set(action.donation.id, action.donation)
      ) as DonationState;

    case SET_DISPLAYED_DONATION_IDS:
      return state.set('displayedDonationIds', action.donationIds) as DonationState;

    case ADD_MULTIPLE:
      return state.set(
        'donations',
        state.get('donations').merge(action.donations)
      ) as DonationState;

    case UPDATE_MULTIPLE:
      // eslint-disable-next-line no-case-declarations
      let donationsState = state.get('donations');
      action.donations.forEach((donation) => {
        const existingDonation = donationsState.get(donation.get('id'));
        donationsState = donationsState.set(donation.get('id'), existingDonation.merge(donation));
      });
      return state.set('donations', donationsState) as DonationState;

    case SET_TOTAL:
      return state.set('total', action.total) as DonationState;

    case SET_PENDING_EXTERNAL_TOTAL:
      return state.set('pendingExternalTotal', action.total) as DonationState;

    case SET_DONATIONS_LOADED:
      return state.set(
        'donationsLoaded',
        state.get('donationsLoaded').add(action.userId)
      ) as DonationState;

    case UPDATE_DONATION_DESIRED_AMOUNT: {
      const updatedDonation = state.get('donations').get(action.donationId);
      return state.set(
        'donations',
        state.get('donations').set(
          action.donationId,
          updatedDonation.merge({
            desiredMatchAmount: action.desiredMatchAmount,
            desiredMatchingRule: action.desiredMatchingRule,
          })
        )
      ) as DonationState;
    }

    default:
      return state;
  }
};
